// utils/sensitiveUrl.js
//
// Verification / reset links arrive as `/verify-email?token=…`. The token is a
// secret; leaving it in the address bar means every third-party script (GA4,
// Clarity, browser extensions) can read it. Before React mounts we move the
// token out of the URL into sessionStorage and rewrite the address bar with
// history.replaceState. Pages read it back through readStashedToken().

const SENSITIVE_PARAMS = ['token', 'code', 'access_token', 'refresh_token', 'id_token', 'authorization', 'state', 'restoreToken'];
const STORAGE_PREFIX = 'aluvo_url_secret:';

function storageKey(pathname, name) {
    return `${STORAGE_PREFIX}${pathname}:${name}`;
}

/** Move sensitive query params out of the current URL. Safe to call repeatedly. */
export function scrubSensitiveQueryParams(win = typeof window !== 'undefined' ? window : null) {
    if (!win?.location || !win.history?.replaceState) return false;
    const url = new URL(win.location.href);
    let changed = false;
    for (const name of SENSITIVE_PARAMS) {
        const value = url.searchParams.get(name);
        if (value === null) continue;
        try { win.sessionStorage.setItem(storageKey(url.pathname, name), value); } catch { /* private mode */ }
        url.searchParams.delete(name);
        changed = true;
    }
    if (changed) {
        const search = url.searchParams.toString();
        win.history.replaceState(win.history.state, '', `${url.pathname}${search ? `?${search}` : ''}${url.hash}`);
    }
    return changed;
}

/** Read a previously scrubbed param for the given route. */
export function readStashedToken(name = 'token', pathname = typeof window !== 'undefined' ? window.location.pathname : '/') {
    try { return window.sessionStorage.getItem(storageKey(pathname, name)); } catch { return null; }
}

/** Forget a stashed secret once it has been used. */
export function clearStashedToken(name = 'token', pathname = typeof window !== 'undefined' ? window.location.pathname : '/') {
    try { window.sessionStorage.removeItem(storageKey(pathname, name)); } catch { /* ignore */ }
}
